import { render, staticRenderFns } from "./FavoriteGame.vue?vue&type=template&id=79702272"
import script from "./FavoriteGame.vue?vue&type=script&lang=js"
export * from "./FavoriteGame.vue?vue&type=script&lang=js"
import style0 from "./FavoriteGame.vue?vue&type=style&index=0&id=79702272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports